import React, { useEffect, useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../Modal";

import ExportSchedulePanel from "./ExportSchedulePanel";

import actions from "@/actions";
import { SummaryState } from "@/reducers/summary";
import { RootState } from "@/reducers/types";

type Props = {
  selectedCategoryCount: number;
  targetItemCount: number;
  scheduleInfo: {
    scheduleDateLists: { id: number; value: string; active: boolean }[];
    initCheck: number;
  };
  onClose: () => void;
};

const SchedulePanelKHNeochem = (props: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { loadingPanel, scheduleSelectedCells } = useSelector<RootState, SummaryState>((state) => state.summary);

  const [scheduleDateIds, setScheduleDateIds] = useState(
    props.scheduleInfo.initCheck == -1 ? [] : [props.scheduleInfo.initCheck]
  );
  const [visibleExportSchedulePanel, setVisibleExportSchedulePanel] = useState(false);

  const panelLeft = useRef<HTMLDivElement>();

  useEffect(() => {
    dispatch(actions.app.setUnloadAlert());
    return () => {
      dispatch(actions.app.clearUnloadAlert());
    };
  }, []);

  const handleSubmit = () => {
    const schedule_dates = props.scheduleInfo.scheduleDateLists
      .filter((item) => scheduleDateIds.includes(item.id))
      .map((item) => item.value);

    dispatch(
      actions.summary.createScheduleKHNeochem({ schedule_dates, schedule_targets: scheduleSelectedCells }, () =>
        setVisibleExportSchedulePanel(true)
      )
    );
  };

  const toggleCheckBox = (id, checked) => {
    if (checked) {
      setScheduleDateIds([...scheduleDateIds, id]);
    } else {
      setScheduleDateIds(scheduleDateIds.filter((item) => item != id));
    }
  };

  const hideExportSchedulePanel = () => {
    setVisibleExportSchedulePanel(false);
    props.onClose();
    dispatch(actions.summary.endSelectSchedule());
  };
  return (
    <Modal title={t("putting_schedule_list")} loading={loadingPanel} closeHandler={props.onClose}>
      <div className="modal-body w-540 schedule-panel">
        <p className="disp-area">
          {t("selected_category")}：<span className="categoryNum txt-bold ">{props.selectedCategoryCount}</span>
          {t("selected_items_sum")}：<span className="targetItems txt-bold ">{props.targetItemCount}</span>
        </p>
        <div className="schedule-inner">
          <div className={`schedule-panel-left ${loadingPanel ? "disabled" : ""}`} ref={panelLeft}>
            <p>{t("date_create_schedule_list")}</p>
            <ul className="schedule-date-list">
              {props.scheduleInfo.scheduleDateLists.map((item) => (
                <li key={item.id}>
                  <label className={"ckbox"}>
                    <input
                      type="checkbox"
                      value={item.id || undefined}
                      disabled={!item.active}
                      checked={scheduleDateIds.some((id) => id === item.id)}
                      onChange={(e) => toggleCheckBox(item.id, e.target.checked)}
                    />
                    <span></span>
                  </label>
                  <span className="baseDate">{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className={`modal-footer ${loadingPanel ? "loading--dialog" : ""}`}>
        <button
          disabled={loadingPanel}
          data-test-id="button-area-edit-cancel"
          type="button"
          className="btn btn-gray"
          onClick={props.onClose}
        >
          {t("cancel")}
        </button>
        <button
          disabled={scheduleDateIds.length > 0 && !loadingPanel ? false : true}
          data-test-id="button-area-edit-save"
          type="button"
          className="btn btn-blue"
          onClick={handleSubmit}
        >
          {t("decision")}
        </button>
      </div>
      {visibleExportSchedulePanel && <ExportSchedulePanel closeHandler={hideExportSchedulePanel} />}
    </Modal>
  );
};

export default withTranslation()(SchedulePanelKHNeochem);
